<template>
  <div class="PerformanceVideo">
    <div class="statusBar"></div>
    <div class="PerformanceContent">
      <div class="video">
        <img src="@/assets/images/detail/back_white.png" alt="" class="back" @click="back" />
        <!-- <video class="video-js" :src="testUrl" controls width="400px" heigt="400px"></video> -->
        <Video id="myVideo" ref="videoPlayer" class="video-js vjs-big-play-centered" :poster="detailInfo.picUrl"> </Video>
      </div>
      <div class="introduction">
        <div class="d-f jc-sb ai-c">
          <span class="title">{{ detailInfo.name }}</span>
          <div class="d-f ai-c view_total">
            <img src="@/assets/images/detail/culturalCollection/view.png" alt="" class="icon" /> <span>{{ detailInfo.pageViewNum }} </span>
          </div>
        </div>
        <div class="common_msg date d-f ai-c">
          <img src="@/assets/images/detail/performance/date.png" alt="" class="icon" />
          <span>发布时间：{{ detailInfo.showedTime }} </span>
        </div>
        <div class="common_msg d-f ai-c">
          <img src="@/assets/images/detail/culturalCollection/company_grey.png" alt="" class="icon" />
          <span>发布单位：{{ detailInfo.publishUnitName }}</span>
        </div>
      </div>
      <div class="operation d-f ai-c jc-sb">
        <div class="operation_item d-f fxd-c ai-c" @click="handlePraise">
          <img src="@/assets/images/detail/performance/zan.png" alt="" class="icon_operation" v-if="!detailInfo.isPraise" />
          <img src="@/assets/images/detail/performance/circle_zan.png" alt="" class="icon_operation" v-else />

          <span>{{ detailInfo.praiseNum }}</span>
        </div>
        <div class="operation_item d-f fxd-c ai-c" @click="handleFavorite">
          <img src="@/assets/images/detail/performance/collect.png" alt="" class="icon_operation" v-if="!detailInfo.isFavorite" />
          <img src="@/assets/images/detail/culturalCollection/collect.png" alt="" class="icon_operation" v-else />

          <span>{{ detailInfo.favoriteNum }}</span>
        </div>
        <div class="operation_item d-f fxd-c ai-c" @click="UNIdownloadFile">
          <img src="@/assets/images/detail/performance/upload.png" alt="" class="icon_operation" />
          <span>下载</span>
        </div>
        <div class="operation_item d-f fxd-c ai-c" @click="share">
          <img src="@/assets/images/detail/performance/share_grey.png" alt="" class="icon_operation" />
          <span style="white-space: pre-wrap; display: inline-block; width: 30px">分享</span>
        </div>
      </div>
      <div class="content">
        <div class="title">视频简介</div>
        <div v-html="detailInfo.detail"></div>
      </div>
    </div>
    <van-share-sheet title="分享到" v-model="showShare" :options="shareOptions" @select="onSelect" />
  </div>
</template>
<script>
import videojs from 'video.js'
import 'videojs-landscape-fullscreen'
import 'video.js/dist/video-js.css'
import { mapGetters } from 'vuex'
import { showVideoDetails, saveWatchLog } from '@/api/performance'
import { submitUserFavorite, cancelFavorite, submitUserPraise, cancelPraise } from '@/api/operation'
import { Notify, Toast, Dialog } from 'vant'
import { getToken, getVenueToken } from '@/utils/auth'
import config from '@/utils/config.js'

export default {
  name: 'PerformanceVideo',
  data() {
    return {
      detailInfo: {},
      showShare: false,
      id: '',
      options: {
        autoplay: false,
        controls: true,
        preload: 'auto',
        sources: [],
        width: '100%',
        height: '100%',
        controlBar: {
          playToggle: true,
          fullscreenToggle: true,
        },
      },
      player: null, // 用来存储当前 video
      testUrl: 'http://vjs.zencdn.net/v/oceans.mp4',
      testPoster: '',
      mediaUrl: require('@/assets/images/detail/performance/video.mp4'), // 播放视频的路径
      timeParams: {
        basicId: '',
        duration: '',
      },
      isPlay: false,
      duration: '',
      isApp: false,
      shareUrl: config.shareUrl,
    }
  },
  computed: {
    ...mapGetters(['shareOptions']),
  },
  methods: {
    UNIdownloadFile() {
      if (getToken()) {
        this.$myUni.postMessage({
          data: {
            methodsName: 'UNIdownloadFile',
            data: this.detailInfo,
          },
        })
      } else {
        this.$myUni.navigateTo({
          url: '/pages/login/index',
        })
      }
    },
    back() {
      if (this.isPlay && this.player.currentTime() < this.player.duration()) {
        this.timeParams.duration = this.player.currentTime()
        this.saveProgress()
      }
      setTimeout(() => {
        this.$myUni.navigateBack({
          delta: 1,
        })
      }, 300)
    },
    share() {
      if (getToken()) {
        this.showShare = true
      } else {
        this.$myUni.navigateTo({
          url: '/pages/login/index',
        })
      }
    },
    async videoInit() {
      // 初始化video.js播放器
      this.$nextTick(() => {
        this.player = videojs('myVideo', this.options)
        this.player.landscapeFullscreen({
          fullscreen: {
            enterOnRotate: true,
            exitOnRotate: true,
            alwaysInLandscapeMode: true,
            iOS: true,
          },
        })

        // var ctrlBar = this.createEle() // 创建一个div节点
        // this.el().appendChild(ctrlBar) // 添加进去，css设置好样式就可以了

        this.player.src(this.detailInfo.videoUrl)
        // this.player.src(this.testUrl)

        this.player.on('play', () => {
          console.log('开始播放')
          this.isPlay = true
          if (this.duration) {
            this.player.currentTime(this.duration)
            this.duration = 0
          }
        })
        this.player.on('ended', () => {
          console.log('播放完成')
        })
        this.player.on('pause', () => {
          this.isPlay = false
          console.log('整体时长', this.player.duration())
          console.log('播放暂停', this.player.currentTime())
          if (this.player.currentTime() < this.player.duration()) {
            this.timeParams.duration = this.player.currentTime()
            this.saveProgress()
          }
        })
        // this.player.on('fullscreenchange', () => {
        //   console.log('全屏切换')
        // })
        // this.player.landscapeFullscreen()
      })
    },
    // createEle() {
    //   var _html = `
    //     <div>
    //       12222
    //     </div>
    //   `
    //   var ctrlBar = document.createElement('div')
    //   ctrlBar.className = 'vjs-mycontrol-bar'
    //   ctrlBar.innerHTML = _html
    //   return ctrlBar
    // },
    saveProgress() {
      if (getToken()) {
        saveWatchLog(this.timeParams).then((res) => {})
      }
    },

    async getDetail() {
      const res = await showVideoDetails(this.id)
      if (res.code == 2000) {
        this.detailInfo = res.result
        // this.detailInfo.videoUrl = this.testUrl
      }
    },
    handlePraise() {
      console.log(this.isApp)
      if (!this.detailInfo.isPraise) {
        // 点赞
        submitUserPraise({ type: 1, basicId: this.id }).then((res) => {
          if (res.code == 2000) {
            // this.getDetail()
            this.detailInfo.praiseNum++
            this.detailInfo.isPraise = true
          }
        })
      } else {
        // 取消点赞
        cancelPraise({ type: 1, basicId: this.id }).then((res) => {
          if (res.code == 2000) {
            // this.getDetail()
            this.detailInfo.praiseNum--
            this.detailInfo.isPraise = false
          }
        })
      }
    },
    handleFavorite() {
      if (!this.detailInfo.isFavorite) {
        // 收藏
        submitUserFavorite({ type: 1, basicId: this.id }).then((res) => {
          if (res.code == 2000) {
            this.detailInfo.favoriteNum++
            this.detailInfo.isFavorite = true
            // this.getDetail()
          }
        })
      } else {
        // 取消收藏
        cancelFavorite({ type: 1, basicId: this.id }).then((res) => {
          if (res.code == 2000) {
            this.detailInfo.favoriteNum--
            this.detailInfo.isFavorite = false
            // this.getDetail()
          }
        })
      }
    },
    onSelect(option) {
      console.log('option====>', option)
      const url = `${this.shareUrl}/share/PerformanceVideo?id=${this.id}`
      this.$myUni.postMessage({
        data: {
          methodsName: 'UNIShare',
          UNISharedata: {
            // 微信好友 朋友圈 QQ好友 复制链接
            shareType: option.name,
            shareUrl: url,
            id: this.id,
            title: this.detailInfo.name,
            subTitle: '',
            picUrl: this.detailInfo.picUrl,
          },
        },
      })
      this.showShare = false
    },
  },
  mounted() {
    const data = JSON.parse(this.$route.query.params)
    this.id = this.timeParams.basicId = data.id
    if (data.duration) {
      this.duration = data.duration
      console.log('duration=====>', this.duration)
    }
    this.getDetail()
    setTimeout(() => {
      this.videoInit()
    }, 300)
    this.isApp = localStorage.getItem('isApp') == 1 ? true : false
    // 判断是否是APP登录
    // console.log('localStorage.getItem(isApp)', localStorage.getItem('isApp'))
  },
  beforeDestroy() {
    this.player.dispose()
  },
}
</script>
<style lang="scss">
.PerformanceVideo {
  width: 100vw;
  height: 100vh;
  background: #fff;
  .statusBar {
    z-index: 10;
    position: fixed;
    top: 0;
    // top: env(safe-area-inset-top);
    left: 0;
    width: 100%;
    height: 40px;
    background: #010101;
  }
  .PerformanceContent {
    width: 100%;
    // height: calc(100% - 40px - env(safe-area-inset-top));
    height: calc(100% - 40px);
    position: absolute;
    // top: calc(40px + env(safe-area-inset-top));
    top: 40px;
    left: 0;
    overflow-y: auto;
  }
  .video {
    width: 100%;
    height: 10.55rem;
    .back {
      z-index: 10;
      position: absolute;
      width: 0.6rem;
      height: 1.2rem;
      left: 0.8rem;
      top: 8px;
      // top: calc(8px + env(safe-area-inset-top));
    }
    .video-js {
      width: 100%;
      height: 10.55rem;
    }
  }
  .introduction {
    padding: 0.8rem 0;
    margin: 0 0.6rem;
    // border-bottom: 1px solid #f4f4f4;
    .icon {
      width: 0.7rem;
      height: 0.7rem;
      margin-right: 2px;
    }
    .title {
      font-size: 0.9rem;
      font-weight: 600;
      color: #212121;
      line-height: 1.4rem;
    }
    .view_total {
      font-size: 0.5rem;
      // color: #47988a;
      color: #a97048;
      text-align: center;
      height: 0.9rem;
      line-height: 0.9rem;
      // background: #dff2f2;
      background: #f9eddc;
      border-radius: 2px;
      padding: 0 0.3rem;
    }
    .common_msg {
      font-size: 0.6rem;
      color: #666666;
      line-height: 0.8rem;
    }
    .date {
      margin: 0.6rem 0 0.3rem 0;
    }
  }
  .operation {
    padding: 0 1.65rem;
    .operation_item {
      font-size: 0.6rem;
      color: #212121;
      line-height: 0.8rem;
      .icon_operation {
        width: 1.4rem;
        height: 1.4rem;
        margin-bottom: 2px;
      }
    }
  }
  .content {
    font-size: 0.7rem;
    color: #666666;
    line-height: 1rem;
    padding: 0 0.6rem;
    .title {
      margin: 1.2rem 0 0.6rem 0;
      font-size: 0.8rem;
      font-weight: 600;
      color: #212121;
      line-height: 1.2rem;
    }
  }
}
</style>
